const translations = {
  "en": {
    "Add account": "Add account",
    "Auto-synced and always up to date": "Auto-synced and always up to date",
    "Bank-level encryption. Read-only — I can't move your money.": "Bank-level encryption. Read-only — I can't move your money.",
    "Connect with Plaid": "Connect with Plaid",
    "I'll read your holdings from a photo": "I'll read your holdings from a photo",
    "Send Ed a screenshot": "Send Ed a screenshot"
  },
  "zh-tw": {
    "Add account": "新增帳戶",
    "Auto-synced and always up to date": "自動同步，隨時保持最新",
    "Bank-level encryption. Read-only — I can't move your money.": "銀行級加密。唯讀模式 — 無法動用您的資金。",
    "Connect with Plaid": "透過 Plaid 連線",
    "I'll read your holdings from a photo": "我將透過照片為您讀取持股。",
    "Send Ed a screenshot": "發送截圖給 Ed"
  }
};

export default translations;
